<template>
  <div>
    <v-container class="print-overview-wrapper">
      <template v-if="isSingleItem">
        <PrintItem :concertId="$route.params.id" />
      </template>
      <template v-else>
        <v-col cols="12" class="d-print-none">
          <h2>Druckübersicht</h2>
        </v-col>
        <PrintItem v-for="(concert, i) in allConcertsToPrint" :key="i" :concertId="concert.konzertdaten.vorst_nr" />
      </template>
    </v-container>
    <div class="print-bar">
      <v-container>
        <v-row>
          <div v-if="isSingleItem">
            <print-single :concertID="$route.params.id" />
          </div>
          <div v-else>
            <print-list />
          </div>
        </v-row>
      </v-container>
    </div>

  </div>
</template>

<script>
import PrintItem from "@/components/PrintItem";
import PrintSingle from "@/components/PrintSingle";
import PrintList from "@/components/PrintList";
import { mapGetters } from "vuex";


export default {
  components: {
    PrintList,
    PrintItem,
    PrintSingle
  },
  computed: {
    ...mapGetters(["allConcertsToPrint"]),
    isSingleItem() {
      return this.$route.name !== "printOverview";
    },
  }
};
</script>

<style lang="scss">

.print-bar {
  position: fixed;
  bottom: 48px;
  left: 0;
  right: 0;
  background-color: #fff;
}

@media only screen and (max-width: 800px) {
  .print-bar {
    position: static;
  }
}

@media only screen and (min-width: 800px) {
  .print-overview-wrapper {
    padding-bottom: 120px;
  }
}



/* Dirty but works - thx to GS */
@media print and (min-width:260px) and (max-width:99999px) {
  @page {
    size: auto;
    margin: 2cm !important;
  }

  * {
    padding: 0 !important;
  }

  body {
    width: 21cm;
    height: 29.7cm;
    background: white;
    overflow: visible;
  }

  .col-12 {
    height: 16cm !important;
  }

  .v-card {
    margin-bottom: 1.5cm;
    border: none !important;
    border-radius: 0 !important;
  }

  .print {
    &__content {
      box-sizing: content-box;
      flex-grow: 1;
      padding: 0 0.5cm !important;

      border: 2px solid black !important;
    }
  }

  .v-application .flex-md-row {
    flex-direction: row !important;
  }

  /* Seitenränder */
  @page {
    margin: 1cm 1.5cm !important;
  }

  /* ganze Seite verwenden */
  body,
  #app .container {
    margin: 0;
    padding: 0;
    float: none;
    height: unset !important;
    width: 100% !important;
  }

  /* "display:flex" stört "break-inside:avoid" */
  #app .row {
    display: block !important;
    margin-top: 0;
  }

  /* Seitenumbruch in Ticket verhindern "break-inside:avoid" (wahrscheinlich nicht SO oft nötig :) ) */
  #app .v-sheet.v-card {
    break-inside: avoid !important;
  }

  #app div.print__content.flex-grow-1 {
    break-inside: avoid !important;
  }

  #app .col.col-12 {
    height: unset !important;
    break-inside: avoid !important;
  }

  /* Rahmen auch um QR-Code herum ("ganzes Ticket") */
  #app div.print__content.flex-grow-1 {
    border: none !important;
    padding-right: 10px !important;
  }

  #app.v-application .py-5 {
    border: 2px solid #888 !important;
    margin: 40px 20px !important;
    padding: 10px 0 0 10px !important;
  }

  /* kompaktere Tickets (Original "line-height:2rem") */
  #app.v-application .text-h5,
  #app.v-application .text-h6 {
    line-height: 1.4rem !important;
  }

  #app.v-application p {
    margin-bottom: 8px;
  }

  /* Saal-Sektor und Sitzplatz in einer Zeile */
  #app div:first-child>p.text-h5.font-weight-bold.mb-0 {
    float: left;
    margin-right: .5em;
  }

  /* KHG-Logo mit weniger white-space (Original: "margin-top:20px;margin-bottom:20px" ) */
  #app div.print__content>div.my-5 {
    margin-top: 10px !important;
    margin-bottom: 5px !important;
  }

}
</style>
